import Local from "../../local";
import { Requests } from "../../../../services";

export type ThunksRateModuleListing = {
  updateStatus: (status: boolean) => any;
  updateMessage: (message: string) => any;
  transferRatesThunk: (body: any) => any;
  airportDetailsThunk: (body: any) => any;
  updateRateThunk: (body: any) => any;
};

const ThunksRateModule: ThunksRateModuleListing = {
  updateStatus: (status) => (dispatch: any, getState: any, mobioApi: any) => {
    dispatch(Local.RateModule.status.statusValue("rateUpdateStatus", status));
  },
  updateMessage: (message) => (dispatch: any, getState: any, mobioApi: any) => {
    dispatch(
      Local.RateModule.status.statusMessage("rateStatusMessage", message)
    );
  },

  // rate search
  transferRatesThunk: (body: any) => (dispatch: any, getState: any, mobioApi: any) => {
    const {
      userInfo: { token },
    } = getState();

    const api: Requests = mobioApi(token);

    return api
      .transferRates(body)
      .then((res: any) => {
        return res.data;
      })
      .catch((error: any) => {
        return error;
      });
  },
  airportDetailsThunk: (body: any) => (dispatch: any, getState: any, mobioApi: any) => {
    const {
      userInfo: { token },
    } = getState();

    const api: Requests = mobioApi(token);

    return api
      .airportDetails(body)
      .then((res: any) => {
        return res.data;
      })
      .catch((error: any) => {
        return error;
      });
  },
  updateRateThunk: (body: any) => (dispatch: any, getState: any, mobioApi: any) => {
    const {
      userInfo: { token },
    } = getState();

    const api: Requests = mobioApi(token);

    return api
      .updateRate(body)
      .then((res: any) => {
        return res.data;
      })
      .catch((error: any) => {
        return error;
      });
  },
};

export default ThunksRateModule;
